// extracted by mini-css-extract-plugin
export default {"form":"NovoUsuario_form__uC8U+","areaBtn":"NovoUsuario_areaBtn__vq84J","btn":"NovoUsuario_btn__CxZBA"};